import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Alert, Tabs, Tab, Table, Button, Form, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from './../../../../utilityComponents/MiniLoader';
import { fetchResourceToBeCreated, startExecution, fetchSpecificPageTopologyData } from './../../../../actions/closeLoop/topology/index';
import PropTypes from "prop-types";


function StartExecutionModal(props) {
    const [ key, setKey ] = useState(0);
    const [ tagName, setTagName ] = useState('');
    const [ username, setUsername ] = useState('');

    useEffect(() => {
        if(props.message) {
            const payload = {
                page: props.page
            };
            props.getSpecificPageData(payload);
        }
    }, [props.message])

    useEffect(() => {
        const payload = {topologyId: props.topologyId}
        props.getResourcesToBeCreated(payload);

        const specificTopology = props.items.find((item) => item['job_id'] === payload['topologyId']);
        setTagName(specificTopology['topology_tag_name'])

    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();

        const specificTopology = props.items.find((item) => item['job_id'] === props.topologyId);
        const data = {
            job_uuid: props.topologyId,
            data: Object.assign({}, ...specificTopology['validate']['config']),
            user: username,
            cad_topology_id: props.topologyId,
            cad_topology_uuid: props.topologyId
        };

        props.initiateExecution(data);
        // Closing the modal.
        props.closeModal();
    }

    return (
        <>
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={props.show}
                onHide={() => props.closeModal()}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Start Execution!
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row style={{ alignItems: "center" }}>
                        <Col md="6" ls="6">
                            { props.loading ? <Loader /> : props.error ?
                             (<Alert variant="danger">{ props.error }</Alert>) : props.resources.length === 0 ?
                             (<Alert>Something went wrong!, Not able to fetch resource yet to be created</Alert>) : (
                                <>
                                    <Tabs
                                        activeKey={key}
                                        onSelect={(k) => setKey(k)}
                                    >
                                        { props.resources.map((item, index) => {
                                            return (
                                                <Tab eventKey={index} title={item['region']} key={item['region']}>
                                                    { item['region'] }
                                                    <>
                                                        <Table striped bordered hover size='md'>
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Resource</th>
                                                                    <th>Quantity</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                { item['resources'].map((subItem, subIndex) => {
                                                                    return (
                                                                        <tr key={subIndex}>
                                                                            <td>{ subIndex }</td>
                                                                            <td>{ subItem['name'] }</td>
                                                                            <td>{ subItem['quantity'] }</td>
                                                                        </tr>
                                                                    )
                                                                }) }
                                                            </tbody>
                                                        </Table>
                                                    </>
                                                </Tab>
                                            )
                                        }) }
                                    </Tabs>
                                </>
                             ) }
                        </Col>
                        <Col md="6" ls="6">
                            <p>Are you sure you want to execute this <strong>{tagName}</strong> topology ?</p>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group>
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type='text'
                                        required
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeholder='Username'
                                        autoFocus
                                    />
                                    <Form.Text>
                                        Please enter your <strong>name</strong> to make an entry in Ticketing system.
                                    </Form.Text>
                                </Form.Group>
                                <Button
                                    style={{backgroundColor: "#757AF7"}}
                                    type="submit"
                                >
                                    { props.loading ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            Loading..
                                        </>
                                    ) : "Confirm" }
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => ({
    loading: state.resourcesToBeCreated.loading,
    error: state.resourcesToBeCreated.error,
    resources: state.resourcesToBeCreated.resources,
    items: state.topology.items,
    message: state.topology.message,
    page: state.topology.page,
});


const mapDispatchToProps = (dispatch) => ({
    getResourcesToBeCreated: (payload) => dispatch(fetchResourceToBeCreated(payload)),
    initiateExecution: (payload) => dispatch(startExecution(payload)),
    getSpecificPageData: (payload) => dispatch(fetchSpecificPageTopologyData(payload)),
});

StartExecutionModal.propTypes = {
    message: PropTypes.string,    
    page: PropTypes.number,
    getSpecificPageData: PropTypes.func,
    topologyId: PropTypes.string,    
    getResourcesToBeCreated: PropTypes.func,
    items: PropTypes.array,
    initiateExecution: PropTypes.func,
    closeModal: PropTypes.func,
    show: PropTypes.bool,
    loading: PropTypes.bool,
    error: PropTypes.string,
    resources: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(StartExecutionModal);